import { StateCreator } from 'zustand';
import { UISlice, KharonStore } from '../types';

export const createUISlice: StateCreator<
  KharonStore,
  [['zustand/devtools', never], ['zustand/immer', never]],
  [],
  UISlice
> = (set) => ({
  isLoading: false,
  error: null,
  selectedService: null,
  isOnboardingActive: false,

  setIsLoading: (loading) => set((state) => { state.isLoading = loading; }, false, 'ui/setIsLoading'),
  setError: (error) => set((state) => { state.error = error; }, false, 'ui/setError'),
  setSelectedService: (service) => set((state) => { state.selectedService = service; }, false, 'ui/setSelectedService'),
  setIsOnboardingActive: (active) => set((state) => { state.isOnboardingActive = active; }, false, 'ui/setIsOnboardingActive'),
});
